import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import {useEffect, useState} from "react";
import {RouteInfo} from "../../route/RouteHelper";
import LogOut from "../Sidebar/logout/LogOut";
import {css} from "@emotion/css";
import SidebarMobile from "../Sidebar/SidebarMobile";
import RaikoDefaultDialogPage, {DialogSize} from "../defaultDialogPage/RaikoDefaultDialogPage";
import ThemeColorToggle from "../ThemeToggle/ThemeColorToggle";
import {Link} from "react-router-dom";
import {ProfileService} from "../../pages/profile/ProfileService";
import {Skeleton} from "@mui/material";
import "./Header.scss";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";

import avatar from '../../assets/images/header/avatar_man.jpg'
import {GeneralService} from "../../serverService/generalService/GeneralService";
import {readToken} from "../../service/authService/AuthService";
import jwt from "jwt-decode";
import {RaikoDivider, showErrorMessage} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {actionTypes} from "../../context/reducer";
import {writeFundId, writeFundName} from "../../service/localStorage/LocalStorageService";


const Header = () => {

    const {title, fundID} = useAuthState()
    const dispatch = useAuthDispatcher()

    const [openDialog, setOpenDialog] = useState(false)

    const handleClickClose = () => {
        setOpenDialog(false)
    }

    const handleClickOpen = () => {
        setOpenDialog(true)
        setAnchorEl(null);
    }

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    const [anchorElFundSelector, setAnchorElFundSelector] = useState(null)
    const openFundSelector = Boolean(anchorElFundSelector)

    function handleClickOnFundSelector(event) {
        setAnchorElFundSelector(event.currentTarget)
    }

    function handleCloseFundSelector() {
        setAnchorElFundSelector(null)
    }


    const [adminName, setAdminName] = useState("")
    const [adminAvatar, setAdminAvatar] = useState("");
    const [adminUsername, setAdminUsername] = useState("");
    const [adminAvatarLoading, setAdminAvatarLoading] = useState(false);

    const [openSettingDialog, setOpenSettingDialog] = useState(false);

    const service = new ProfileService()
    const [adminNameLoadingState, setAdminNameLoadingState] = useState(false);

    useEffect(() => {
        if (typeof service !== 'undefined') {
            setAdminNameLoadingState(true)
            service.getProfileDetail()
                .then(response => {
                    setAdminName(`${response.firstName} ${response.lastName}`)
                    setAdminUsername(response.username)
                }).catch(reason => {
            }).finally(_ => {
                setAdminNameLoadingState(false)
            })


            getFundsList()

            /*setAdminAvatarLoading(true)

            service.getAvatarAdmin()
                .then(response => {
                    setAdminAvatar(response.downloadUrl.replaceAll('http:', 'https:'))
                }).catch(reason => {

            }).finally(_ => {
                setAdminAvatarLoading(false)
            })*/
        }
    }, [])

    const [funds, setFunds] = useState([]);
    const [fundLoadingState, setFundLoadingState] = useState(false);


    function getFundsList() {
        const token = readToken()
        setFunds([])
        setFundLoadingState(true)

        if (jwt(token).total_owner === true) {
            new GeneralService()
                .getAvailableCashList(
                    0,
                    1000
                ).then(response => {
                response.data.map((item, index) => {
                    setFunds(prev => [
                        ...prev,
                        {
                            id: item.id,
                            name: item.name
                        }
                    ])
                })
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setFundLoadingState(false)
            })
        } else {
            setFunds([
                {
                    id: fundID,
                    name: title
                }
            ])

            setFundLoadingState(false)
        }

    }


    return (
        <>
            {
                <LogOut
                    openDialog={openDialog}
                    handleClickClose={handleClickClose}
                />
            }
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setOpenSettingDialog(false)
                }}
                open={openSettingDialog}
                selectedValue={""}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle="تنظیمات">
                <ThemeColorToggle/>
            </RaikoDefaultDialogPage>


            <header>
                <section className="headerContainer">

                    <div>
                        <div
                            className={"headerUserInfoContainer"}
                            id="btn-dropdown"
                            onClick={handleClick}
                        >
                            {
                                adminAvatarLoading ?
                                    <Avatar
                                        className={"headerUserAvatar"}
                                        id="avatar"
                                        alt="avatar"
                                        src={""}
                                    />
                                    :
                                    <Avatar
                                        className={"headerUserAvatar"}
                                        id="avatar"
                                        alt={adminUsername}
                                        src={adminAvatar && adminAvatar.length > 0 ? adminAvatar : avatar}
                                    />
                            }


                            <div className={"usernameContainer"}>
                                <span className={"usernameContainerTitle"}>{adminName}</span>
                                {adminNameLoadingState ?
                                    <Skeleton
                                        variant="rectangular"
                                        className={css`
                                          padding: 8px;
                                          min-width: 120px;`
                                        }/> :
                                    <span className={"usernameText"}>{title}</span>
                                }
                            </div>
                            <div className="dropdown-item-icon ic-arrow-left"/>
                        </div>
                        <Menu
                            id="demo-customized-menu"
                            MenuListProps={{
                                'aria-labelledby': 'demo-customized-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            /*    anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}*/
                        >
                            <Link to={RouteInfo.Profile.globalUrl}>
                                <MenuItem
                                    onClick={handleClose}
                                    disableRipple
                                    onMouseLeave={handleCloseFundSelector}
                                >
                                    <section className="dropdown-item-icon account-icon"/>
                                    حساب کاربری
                                </MenuItem>
                            </Link>

                            <MenuItem
                                className={"changeFundButtonContainer"}
                            >
                                <div className={"changeFundButton"}>
                                    <span>تعویض صندوق</span>
                                    <div className={"ic-arrow-left"}/>
                                </div>

                                <div className={"changeFundItemsContainer"}>
                                    {
                                        fundLoadingState ?
                                            <Skeleton variant="rectangular" className={css`padding: 16px`}/> :
                                            funds.map((item, index) => {
                                                return <div
                                                    key={index}
                                                    className={parseInt(item.id) === parseInt(fundID) && "fundItemActiveState"}
                                                    onClick={_ => {
                                                        writeFundName(item.name)
                                                        writeFundId(item.id)

                                                        dispatch({
                                                            type: actionTypes.CHANGE_FUND,
                                                            fundID: item.id,
                                                            title: item.name
                                                        })

                                                        handleClose()

                                                    }}
                                                >
                                                    <span>{item.name}</span>
                                                    {
                                                        parseInt(item.id) === parseInt(fundID) ?
                                                            <div className={"ic-tick"}/> : ""
                                                    }
                                                </div>
                                            })
                                    }
                                </div>
                            </MenuItem>

                            <RaikoDivider/>
                            <MenuItem
                                onClick={handleClickOpen}
                                disableRipple
                                onMouseLeave={handleCloseFundSelector}
                            >
                                <section className="dropdown-item-icon logOut-icon"/>
                                خروج
                            </MenuItem>
                        </Menu>

                        <Menu
                            id="demo-customized-menu"
                            MenuListProps={{
                                'aria-labelledby': 'demo-customized-button',
                            }}
                            anchorEl={anchorElFundSelector}
                            open={openFundSelector}
                            onClose={handleCloseFundSelector}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}

                            transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}

                        >

                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div
                                    onClick={handleCloseFundSelector}
                                >
                                    <span>click for close</span>
                                </div>
                            </MenuItem>

                        </Menu>
                    </div>
                    {/*<DarkModeToggle/>*/}
                    <div className={css`flex-grow: 1`}>
                        <SidebarMobile/>
                    </div>
                </section>
            </header>
        </>

    )
}
export default Header;
